import { render, staticRenderFns } from "./MerchantMainBody.vue?vue&type=template&id=2cf88c68&"
import script from "./MerchantMainBody.vue?vue&type=script&lang=js&"
export * from "./MerchantMainBody.vue?vue&type=script&lang=js&"
import style0 from "./MerchantMainBody.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports